import React from "react";

export default function MapsPinIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 341.334 512"
            fill="currentColor"
            {...props}
        >
            <g transform="translate(-85.333)">
                <path d="M256,0C161.9,0,85.333,76.563,85.333,170.667a170.986,170.986,0,0,0,20.49,81.1L246.667,506.5a10.669,10.669,0,0,0,18.666,0l140.9-254.813a170.969,170.969,0,0,0,20.438-81.021C426.667,76.563,350.1,0,256,0Zm0,256a85.333,85.333,0,1,1,85.333-85.333A85.431,85.431,0,0,1,256,256Z" />
            </g>
        </svg>
    );
}
